// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './Result.css'

import { ResultList } from './components/ResultList/ResultList'

import type { Result as ResultType, ResultItem } from '../../types'
import { Error } from '../Error/Error'
import { Loader } from '../Loader/Loader'
import { StemningIcon } from '../StemningIcon/StemningIcon'
import { RetryButton } from '../../widgets/LivePoll/components/LivePoll/RetryButton/RetryButton'

type Props = {
  sort?: 'ASC' | 'DESC',
  result: ?ResultType,
  error?: ?Error,
  title?: string,
  highlightedResultItemId?: ?number,
  clickable?: boolean
}

export class Result extends Component<Props> {
  handleRetryButtonClick () {
    window.location.reload(true)
  }

  render () {
    const {
      error,
      result,
      title,
      highlightedResultItemId,
      sort,
      clickable
    } = this.props

    const totalVotes = (result && result.votes) || 0
    if (error && !result) {
      return (
        <Error>
          <div style={{ marginBottom: '10px' }}>
            Beklager, men vi klarte ikke å laste inn resultater akkurat nå.
          </div>
          <RetryButton onClick={this.handleRetryButtonClick}>Prøv på nytt</RetryButton>
        </Error>
      )
    }

    if (!result) {
      return (
        <Loader>
          <StemningIcon />
          <p>Laster innhold</p>
        </Loader>
      )
    }

    const TitleBar = () => {
      if (title && (totalVotes === 0 || totalVotes)) {
        return (
          <div className={styles.result__titleBar}>
            <h4 className={styles.result__title}>{title}</h4>
          </div>
        )
      }
      return null
    }

    return (
      <div className={styles.result}>
        <TitleBar />

        <ResultList
          clickable={clickable}
          items={sortItems(result.items, sort)}
          totalVotes={result.votes || result.totalVotes}
          highlightedId={highlightedResultItemId}
        />
      </div>
    )
  }
}

function sortItems (items: ResultItem[], sort?: 'ASC' | 'DESC') {
  if (sort === 'DESC') {
    return items.sort((a: ResultItem, b: ResultItem) => b.votes - a.votes)
  } else if (sort === 'ASC') {
    return items.sort((a: ResultItem, b: ResultItem) => a.votes - b.votes)
  }

  return items
}



// WEBPACK FOOTER //
// ./src/shared/components/Result/Result.js